import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";

import {
  blackBaseButtonStyle,
  whiteBaseButtonStyle,
} from "./styles/commonStyles";

export const containerStyle = css`
  background-color: #f5f5f5;
  min-height: 100%;
  padding: 24px 20px;

  ${MEDIA_QUERY_FOR_PC} {
    // 下部の白い領域を画面下まで伸ばすための調整
    padding-bottom: 80px;
    margin-bottom: -80px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    padding-bottom: 24px;
    // 下部の白い領域を画面下まで伸ばすための調整
    margin-bottom: -80px;
  }
`;

export const contentWrapperStyle = css`
  margin-inline: auto;

  ${MEDIA_QUERY_FOR_PC} {
    width: 640px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    width: 100%;
    min-width: 360px;
  }
`;

export const titleStyle = css`
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
  margin-bottom: 24px;
`;

export const informationStyle = css`
  background-color: #fff;
  border: 1px solid #d4d4d4;

  ${MEDIA_QUERY_FOR_PC} {
    padding-bottom: 24px;
  }
`;

export const whiteActionButtonStyle = css`
  ${whiteBaseButtonStyle}
  width: 328px;
`;

export const blackActionButtonStyle = css`
  ${blackBaseButtonStyle}
  width: 328px;
`;

export const skeletonButtonStyle = css`
  ${blackBaseButtonStyle}
  width: 328px;
  background: linear-gradient(90deg, #333 25%, #555 50%, #333 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  pointer-events: none;

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;
